import Mutations from '../../odata/mutations';

export default { ...new Mutations('approvalResponse'), ...new Mutations('approvalResponses') };
